import React, { useCallback } from 'react';
import { BestPractice } from './types';
import { AiAgent } from '../aiAgentCenter/aiAgentsConsts';
import useAiAgents from '../aiAgentCenter/useAiAgents';
import BestPracticeCardBase from './BestPracticeCardBase';

interface EditableBestPracticeCardProps {
  bestPractice: BestPractice;
  isCustom: boolean;
  index: number;
  onIsPristineChange?: (isPristine: boolean) => void;
  agent?: AiAgent | null;
  crmOrgId: string;
}

const EditableBestPracticeCard: React.FC<EditableBestPracticeCardProps> = ({
  bestPractice,
  isCustom,
  index,
  onIsPristineChange,
  agent,
  crmOrgId,
}) => {
  const { addAgentBestPractices, removeAgentBestPractices } = useAiAgents();

  const isToggleChecked =
    agent?.bestPractices?.map((bp) => bp.bestPracticeId).includes(bestPractice.id) ?? false;

  const handleToggleActive = useCallback(
    async (isActive: boolean) => {
      if (agent) {
        if (isActive) {
          await addAgentBestPractices(agent.id, [bestPractice.id]);
        } else {
          await removeAgentBestPractices(agent.id, [bestPractice.id]);
        }
      }
    },
    [bestPractice.id, agent, addAgentBestPractices, removeAgentBestPractices],
  );

  return (
    <BestPracticeCardBase
      bestPractice={bestPractice}
      isCustom={isCustom}
      index={index}
      onIsPristineChange={onIsPristineChange}
      agent={agent}
      onToggleActive={handleToggleActive}
      isToggleChecked={isToggleChecked}
      showToggle={!!agent}
      crmOrgId={crmOrgId}
    />
  );
};

export default EditableBestPracticeCard;
